import { Mail, MapPin, Clock, ArrowUp } from "lucide-react";
import { Logo, LogoMark } from "./Logo";
import { scrollToHash } from "./Header";

export default function Footer() {
  const go = (e, hash) => {
    e.preventDefault();
    scrollToHash(hash);
  };

  return (
    <footer data-testid="site-footer" className="border-t-4 border-ink bg-ink text-cream">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo dark />
            <p className="font-logo mt-5 text-2xl text-sunburst">The Snack That's Always a Treat!</p>
            <div className="mt-6 inline-block rounded-2xl border-[3px] border-cream/20 bg-white p-4 shadow-[4px_4px_0_0_rgba(255,198,41,0.9)]">
              <img src="/brand/logo-full.png" alt="The official Sy Sy's Snacks logo" className="h-16 w-auto sm:h-20" />
            </div>
            <p className="mt-4 max-w-sm text-sm font-semibold leading-relaxed text-cream/70">
              Youth-run snack catering from Bakersfield, CA. Vendor events, school events and
              birthday parties, powered by the famous Nacho Box.
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-sunburst">Book us for</h3>
            <ul className="mt-4 space-y-2.5">
              {[
                { label: "Vendor Events", hash: "#events" },
                { label: "School Events", hash: "#events" },
                { label: "Birthday Parties", hash: "#events" },
                { label: "Our Menu", hash: "#menu" },
              ].map((l) => (
                <li key={l.label}>
                  <a
                    href={l.hash}
                    onClick={(e) => go(e, l.hash)}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-sm font-bold text-cream/80 transition-colors duration-200 hover:text-sunburst"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-sunburst">Say hello</h3>
            <ul className="mt-4 space-y-3.5 text-sm font-bold">
              <li className="flex items-start gap-3">
                <Mail className="mt-0.5 h-5 w-5 shrink-0 text-tang" strokeWidth={2.75} />
                <a
                  href="mailto:sysyssnacks@gmail.com"
                  data-testid="footer-email-link"
                  className="text-cream/90 underline decoration-sunburst decoration-2 underline-offset-4 transition-colors duration-200 hover:text-sunburst"
                >
                  sysyssnacks@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="mt-0.5 h-5 w-5 shrink-0 text-tang" strokeWidth={2.75} />
                <span className="text-cream/90">Bakersfield, CA 93311</span>
              </li>
              <li className="flex items-start gap-3">
                <Clock className="mt-0.5 h-5 w-5 shrink-0 text-tang" strokeWidth={2.75} />
                <span className="text-cream/90">Hours: based on event. Book us &amp; we roll up</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t-2 border-cream/15">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-6 sm:px-6">
          <p className="text-xs font-bold uppercase tracking-wider text-cream/50">
            © {new Date().getFullYear()} Sy Sy's Snacks. Run by a high school senior in Bakersfield
          </p>
          <button
            type="button"
            data-testid="footer-back-to-top"
            onClick={() => scrollToHash("#top")}
            className="inline-flex items-center gap-2 rounded-full border-2 border-cream/30 px-4 py-2 text-xs font-black uppercase tracking-wider text-cream/70 transition-all duration-200 hover:border-sunburst hover:text-sunburst"
          >
            Back to top <ArrowUp className="h-3.5 w-3.5" strokeWidth={3} />
          </button>
        </div>
      </div>
    </footer>
  );
}
